import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _wrapNativeSuper from "@babel/runtime/helpers/wrapNativeSuper";
function _createSuper(t) { var r = _isNativeReflectConstruct(); return function () { var e, o = _getPrototypeOf(t); if (r) { var s = _getPrototypeOf(this).constructor; e = Reflect.construct(o, arguments, s); } else e = o.apply(this, arguments); return _possibleConstructorReturn(this, e); }; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
export var MediaFileStateError = /*#__PURE__*/function (_Error) {
  _inherits(MediaFileStateError, _Error);
  var _super = _createSuper(MediaFileStateError);
  function MediaFileStateError(id, reason) {
    var _this;
    var message = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    var details = arguments.length > 3 ? arguments[3] : undefined;
    _classCallCheck(this, MediaFileStateError);
    _this = _super.call(this, reason);
    // https://www.typescriptlang.org/docs/handbook/release-notes/typescript-2-2.html#support-for-newtarget
    _this.id = id;
    _this.reason = reason;
    _this.message = message;
    _this.details = details;
    Object.setPrototypeOf(_assertThisInitialized(_this), (this instanceof MediaFileStateError ? this.constructor : void 0).prototype);

    // https://v8.dev/docs/stack-trace-api
    if ('captureStackTrace' in Error) {
      Error.captureStackTrace(_assertThisInitialized(_this), this instanceof MediaFileStateError ? this.constructor : void 0);
    }
    return _this;
  }
  return _createClass(MediaFileStateError);
}( /*#__PURE__*/_wrapNativeSuper(Error));